// @ts-nocheck
import { startCase } from "lodash";

import { unitTypeOptions } from "../AddressManualEntry/options";
import { Address, AddressResult } from "../models";

export const constructDisplayLabel = ({
  unit,
  streetNumber,
  streetName,
  city,
  state,
  postcode,
}: Address): string => {
  const unitTypeAndUnitNumber = unit && unit.split(" ");
  let unitTypeString = "";
  let unitNumberString = "";

  if (unitTypeAndUnitNumber && unitTypeAndUnitNumber.length > 1) {
    unitTypeString = unitTypeAndUnitNumber[0].trim();
    unitNumberString = unitTypeAndUnitNumber[1].trim();
  }

  const unitLabel = getUnitLabel(unitTypeString);

  return `${unitLabel ? unitLabel : unitTypeString ? unitTypeString : ""} ${
    unitNumberString || ""
  } ${streetNumber} ${startCase(
    streetName.toLocaleLowerCase()
  )}, ${city} ${state} ${postcode}`.trim();
};

export const constructQASLabel = ({
  unitType,
  unitNumber,
  streetNumber,
  streetName,
  city,
  state,
  postcode,
}: Address): string =>
  `${unitType || ""} ${unitNumber || ""} ${streetNumber} ${startCase(
    streetName.toLocaleLowerCase()
  )}, ${city} ${state} ${postcode}`.trim();

export const getOptionLabel = (option?: AddressResult): string | undefined =>
  option ? option.label : "";

export const createSafeLabel = (value: string): string =>
  value.split("").join("\u200b");

export const call = (fn, ...params): void => {
  if (typeof fn === "function") {
    fn(...params);
  }
};

export const getUnitLabel = (unit: string): string => {
  const units = unitTypeOptions.filter(
    (u) => u.value.toLowerCase() == unit.toLowerCase()
  );
  return units && units.length > 0 ? units[0].label : "";
};
